import { useState } from "react";
import { Box, Chip, Collapse, IconButton, Stack, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import type { Dayjs } from "dayjs";
import type { ReceivedInviteGroup } from "../../utils/groupReceivedInvites";
import { ReceivedInviteCard } from "./ReceivedInviteCard";
import { INVITE_TONE_DOT } from "./inviteTone";

interface ReceivedInvitesGroupProps {
  group: ReceivedInviteGroup;
  now: Dayjs;
}

/** Título do grupo + contador + cards. Só "Anteriores" é recolhível. */
export function ReceivedInvitesGroup({ group, now }: ReceivedInvitesGroupProps) {
  const [open, setOpen] = useState(!group.defaultCollapsed);
  const titleId = `teleconsultoria-invites-${group.key}`;

  return (
    <Box component="section" aria-labelledby={titleId}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Box
          aria-hidden
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: INVITE_TONE_DOT[group.tone],
          }}
        />
        <Typography
          id={titleId}
          variant="subtitle2"
          fontWeight={700}
          color="text.secondary"
          sx={{ textTransform: "uppercase", letterSpacing: 0.5 }}
        >
          {group.title}
        </Typography>
        <Chip size="small" label={group.items.length} sx={{ height: 20 }} />
        {group.defaultCollapsed && (
          <IconButton
            size="small"
            onClick={() => setOpen((value) => !value)}
            aria-expanded={open}
            aria-controls={`${titleId}-list`}
            aria-label={open ? `Recolher ${group.title}` : `Expandir ${group.title}`}
          >
            {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
          </IconButton>
        )}
      </Stack>

      <Collapse in={open}>
        <Stack id={`${titleId}-list`} spacing={1} role="list">
          {group.items.map((invite) => (
            <ReceivedInviteCard
              key={invite.appointmentId}
              invite={invite}
              tone={group.tone}
              now={now}
            />
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
}
